import { createAction } from 'redux-actions'

export const bookingAddService = createAction('BOOKING:ADDSERVICE')
export const bookingRemoveService = createAction('BOOKING:REMOVESERVICE')

export const bookingSelectDay = createAction('BOOKING:SELECTDAY')
export const bookingSelectHour = createAction('BOOKING:SELECTHOUR')
export const bookingSetUserData = createAction('BOOKING:SETUSERDATA')

export const bookingReset = createAction('BOOKING:RESET')

export const bookingError = createAction('BOOKING:ERROR')
